<mat-horizontal-stepper #hStepper [linear]="true">
  <mat-step [stepControl]="firstFormGroup">
    <ng-template mdStepLabel>Select Role</ng-template>
    <data-table (custom)="selectScreen($event)"
                    [columns]="[{prop: 'name'}]"
                    [dataProviderParams]="{ customerId: customerId }"
                    [dataProvider]="screenService"
                    [hideSearch]="true"
                    icon="done">
    </data-table>
    <form [formGroup]="firstFormGroup">
      <input [(ngModel)]="selectedScreenId" formControlName="screenId" required type="hidden">
    </form>
  </mat-step>
  <mat-step>
    <ng-template mdStepLabel>Done</ng-template>
    <p>
      Clone Settings from Screen {{boundScreen?.name}}?
    </p>
    <div>
      <button (click)="abort()" color="accent" mat-raised-button>Abort</button>
      <button (click)="save()" color="primary" mat-raised-button>Clone</button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
